import { FC } from 'react'
import { observer } from 'mobx-react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { ISkillBase } from '../../../types'
import { useStores } from '../../../utils'
import { ValidationErrorMessage } from '../../atoms/ValidationErrorMessage'
import { SettingButton } from '../../atoms/SettingButton'

type FormValues = {
  nameOfSubForm: string
}

type Props = {
  searchWord: string
  onCreateSkill: (skill: ISkillBase) => void
  onClickCancelButton: () => void
}

export const SkillCreationField: FC<Props> = observer(({ searchWord, onCreateSkill, onClickCancelButton }) => {
  const { companies } = useStores()
  const { t } = useTranslation(['account-job', 'validation'])

  const formik = useFormik<FormValues>({
    initialValues: {
      nameOfSubForm: searchWord,
    },
    validationSchema: Yup.object({
      nameOfSubForm: Yup.string().required(t('validation:必須項目です')),
    }),
    onSubmit: () => {},
  })

  const onSubmit = async () => {
    formik.setSubmitting(true)
    const skill = await companies.createSkill({
      name: formik.values.nameOfSubForm,
    })
    formik.setSubmitting(false)
    if (skill) {
      onCreateSkill(skill)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <p className={styles.required}>{t('スキル名')}</p>
        <input
          type='text'
          className={styles.input}
          name='nameOfSubForm'
          value={formik.values.nameOfSubForm}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.nameOfSubForm && formik.errors.nameOfSubForm && (
          <div className={styles.message}>
            <ValidationErrorMessage>{formik.errors.nameOfSubForm}</ValidationErrorMessage>
          </div>
        )}
      </div>
      <div className={styles.formButton}>
        <SettingButton
          color='blue'
          buttonType='button'
          isLoading={formik.isSubmitting}
          onClick={async () => onSubmit()}
          disabled={!formik.isValid || formik.isSubmitting}
        >
          {t('スキルを作成する')}
        </SettingButton>
        <SettingButton
          color='white'
          buttonType='button'
          onClick={() => onClickCancelButton()}
          disabled={formik.isSubmitting}
        >
          {t('キャンセル')}
        </SettingButton>
      </div>
    </div>
  )
})
